import React, { Component } from 'react';
import * as styled from './about.styled';

class Logo extends Component {

    constructor() {
        super();
    }

    componentDidCatch(){}

    render() {
        return (
            <styled.Container id="about" className={this.props.isMobileVersion ? 'mobileVersion' : null}>
                <styled.Section>
                    <styled.Title className={this.props.isMobileVersion ? 'mobileVersion' : null}><h2><span style={{fontStyle: 'italic'}}>fashion</span><br/>photography</h2></styled.Title>
                    <styled.Text className={this.props.isMobileVersion ? 'mobileVersion' : null}>
                        “As a fashion photographer for almost two decades, I have
                        searched for beauty, creating it and recording it. Beauty happens
                        on ones own terms. My search for the beauty found in someone’s
                        own sight, has informed most of my decisions at both aesthetical
                        and technical levels and it has guided my personal initiative as
                        well as my own critical sense.”
                    </styled.Text>
                    <styled.Text className={this.props.isMobileVersion ? 'mobileVersion' : null}>
                        Malina Corpadean is a creative director and photographer
                        based in Canada.
                    </styled.Text>
                    <styled.Text className={this.props.isMobileVersion ? 'mobileVersion' : null}>
                        She considers herself fortunate to have worked with some of Canada’s
                        leading brands and agencies while still drawing pleasure from the
                        liberty to experiment with her personal work.
                    </styled.Text>
                    <styled.Text className={this.props.isMobileVersion ? 'mobileVersion' : null}>
                        Malina’s work showcases her natural ability to shoot both fashion
                        and portraiture in a contemporary and elegant way.
                    </styled.Text>
                    <styled.Text className={this.props.isMobileVersion ? 'mobileVersion' : null}>
                        Her simple approach to both lighting and composition highlight
                        the natural beauty of her subjects.
                    </styled.Text>
                    <styled.Text className={this.props.isMobileVersion ? 'mobileVersion' : null}>
                        The key behind her continued success is her collaborative nature
                        and process which result in enhancing the client’s concept and narrative.
                    </styled.Text>
                    <styled.Text className={this.props.isMobileVersion ? 'mobileVersion' : null}>
                        Her love for her craft keeps her approach fresh and relevant;
                        her mandates range from high-end fashion brands to advertising
                        campaigns for agencies as well as corporate assignments. Her
                        commitment to sustainable fashion has resulted in noteworthy
                        photography campaigns that make clear the connection between humans, 
                        fashion and their environment. 
                        Her latest campaign blurs the boundaries between fashion photography and
                        art initiave.
                    </styled.Text>
                </styled.Section>
                <styled.Section>
                    <styled.SubtitleContainer className={'desktop-only ' + (this.props.isMobileVersion ? 'mobileVersion' : null)}>
                        <styled.Subtitle>
                            elegant,<br/>
                            natural,<br/>
                            beauty,<br/>
                            concept,<br/>
                            narrative,<br/>
                            fresh,<br/>
                            relevant.
                        </styled.Subtitle>
                    </styled.SubtitleContainer>
                    <styled.Text className={this.props.isMobileVersion ? 'mobileVersion' : null}>
                        Contact the studio directly:<br/>
                        <a href="mailto:info@malinacorpadean.com" target="_blank">info@malinacorpadean.com</a><br/>
                        <a href="tel:+1-514-812-2627">+1 (514) 812-2627</a>
                    </styled.Text>
                    <styled.Text className={this.props.isMobileVersion ? 'mobileVersion' : null}>
                        <a href="https://www.instagram.com/malinacorpadean" target="_blank">Instagram – @malinacorpadean</a><br/>
                        <a href="https://www.facebook.com/MalinaCorpadean" target="_blank">Facebook – Malina Corpadean</a><br/>
                        <a href="https://www.linkedin.com/in/malinacorpadean" target="_blank">LinkedIn – Malina Corpadean</a>
                    </styled.Text>
                    <styled.Text className={this.props.isMobileVersion ? 'mobileVersion' : null}>
                        All content copyright © 2020 Malina Corpadean. All Rights Reserved.
                    </styled.Text>
                    <styled.Text className={this.props.isMobileVersion ? 'mobileVersion' : null}>
                        Website design by Abbruzzo+Associates.
                    </styled.Text>
                </styled.Section>
            </styled.Container>
        );
    }
}

export default Logo;